import React from 'react'
import styled from 'styled-components'
import Img from 'gatsby-image'

const StyledImage = styled.div`
  float: left;
  margin: 10px;
  text-align: center;
  width: 400px;

  &:hover {
    cursor: ${props => (props.noZoom ? 'default' : 'zoom-in')};
  }

  @media (max-width: 1260px) {
    width: 280px;
    height: 280px;
    margin: 10px;
    .gatsby-image-wrapper {
      width: 280px !important;
      height: 280px !important;
    }
  }

  @media (max-width: 500px) {
    width: 90%;
  }

  img {
    border-radius: 2px;
  }
`

interface IModalProps {
  visible: boolean
}

const Modal = styled<IModalProps, any>('div')`
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 99999;

  .gatsby-image-outer-wrapper {
    width: 60%;
    border-radius: 4px;
    overflow: hidden;
    max-width: 900px;

    @media (max-width: 860px) {
      width: 80%;
    }
    @media (max-width: 520px) {
      width: 95%;
    }
  }
`

const BG = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
`

interface IProps {
  modal: object
  noModal: boolean
}

interface IState {
  modalVisible: boolean
}

class GalleryImage extends React.Component<IProps, IState> {
  state = {
    modalVisible: false
  }

  render() {
    return (
      <>
        <StyledImage
          className="masonry-columns"
          noZoom={this.props.noModal}
          onClick={() => {
            if (this.props.noModal) {
              return null
            }
            this.setState({ modalVisible: true })
          }}
        >
          {this.props.children}
        </StyledImage>
        {this.state.modalVisible && (
          <Modal visible={this.state.modalVisible}>
            <BG
              onClick={() => {
                this.setState({ modalVisible: false })
              }}
            />
            <Img fluid={this.props.modal} />
          </Modal>
        )}
      </>
    )
  }
}

export default GalleryImage
